import {
  getProductionV1Data,
  patchProductionV1Data,
  putProductionV1Data,
  deleteProductionV1Data,
} from 'services/productionV1';

export async function getUser(userId) {
  let response = '';
  let errorMessage = '';  
  try {
    response = await getProductionV1Data({
      url: `/users/${userId}`,
      withAuth: true,
    });
  } catch (error) {
    if (error.apiStatusCode === '404') {
      errorMessage = 'User Details Not Found';
    } else {
      errorMessage = error.message;
    }
  }
  return { response, errorMessage };
}

export async function getUsers(reqParams) {
  let response = '';
  let errorMessage = '';  
  try {
    response = await getProductionV1Data({
      apiConfig: {
        params: reqParams,
      },
      url: '/users',
      withAuth: true,
    });
  } catch (error) {
    errorMessage = error.message;
  }
  return { response, errorMessage };
}

export async function patchUser({ userId, data }) {
  let response = '';
  let errorMessage = '';  
  try {
    response = await patchProductionV1Data({
      data,
      url: `/users/${userId}`,
      withAuth: true,
    });
  } catch (error) {
    errorMessage = error.message;
  }
  return { response, errorMessage };
}

export async function putUser({ userId, data }) {
  await putProductionV1Data({
    data,
    url: `/users/${userId}`,
    withAuth: true,
  });
}

export async function deleteUser(userId) {
  let response = '';
  let errorMessage = '';  
  try {
    response = await deleteProductionV1Data({
      url: `/users/${userId}`,
      withAuth: true,
    });
  } catch (error) {
    errorMessage = error.message;
  }
  return { response, errorMessage };
}